import React, { useEffect } from 'react';
import PageMeta from '../components/PageMeta';
import ProcessSteps from '../components/ProcessSteps';
import ReasonsList from '../components/ReasonsCard';
import FAQAccordion from '../components/FAQAccordion';
import ContactButton from '../components/ContactButton';
import SuccessStoriesSlider from '../components/SuccessStoriesSlider';
import HomepageEligibilitySection from '../components/HomepageEligibilitySection';
import SimpleContactButton from '../components/SimpleCBT';

const HERO_IMAGE = '/חן3.jpg';

const ServiceLandingPage = ({
  title,
  metaDescription,
  path,
  h1,
  sections = [],
  steps,
  faq = [],
  faqSubtitle,
  showSuccessStories = false,
  successStoryImages,
  midPageCta = 'contact',
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [path]);

  return (
    <>
      <PageMeta title={title} description={metaDescription} path={path} />
      <div className="flex-grow bg-gray-100 text-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="lg:grid lg:grid-cols-1 items-start">
            <div className="relative mb-8 lg:mb-0">
              <div className="relative w-full aspect-video md:aspect-w-16 md:aspect-h-9 overflow-hidden rounded-xl shadow-2xl">
                <img
                  src={HERO_IMAGE}
                  alt={h1}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8">
                  <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white text-shadow-lg">
                    {h1}
                  </h1>
                </div>
              </div>

              <div className="mt-8">
                {sections.length > 0 && (
                  <section className="mb-10">
                    <div className="prose prose-lg max-w-none w-full mx-auto text-gray-800">
                      <h2>{sections[0].title}</h2>
                      {sections[0].content}
                    </div>
                  </section>
                )}
                {midPageCta === 'contact' ? (
                  <ContactButton className="mt-4 mb-12 md:mb-16" />
                ) : (
                  <HomepageEligibilitySection showWave={false} />
                )}
                {sections.slice(1).map((section, index) => (
                  <section key={index + 1} className="mb-10 last:mb-0">
                    <div className="prose prose-lg max-w-none w-full mx-auto text-gray-800">
                      <h2>{section.title}</h2>
                      {section.content}
                    </div>
                  </section>
                ))}
              </div>
            </div>
          </div>

          <SimpleContactButton className="mt-8" />
          <ProcessSteps steps={steps} />
        </div>

        <div className="bg-white">
          <div className="h-16 md:h-24" />
          <ReasonsList />
          {showSuccessStories && <SuccessStoriesSlider images={successStoryImages} />}

          <FAQAccordion items={faq} subtitle={faqSubtitle} />
          <ContactButton className="pb-12 md:pb-16" />
        </div>
      </div>
    </>
  );
};

export default ServiceLandingPage;
